import { CommonModule } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { CombinedStore } from 'src/app/core/combined.store';
import { ClimaticStatusCodeEnum } from 'src/app/shared/enum/climatic.enum';

@Component({
  selector: 'app-vyv-api-climatic',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vyv-api-climatic.component.html',
  styles: [],
})
export class VyvApiClimaticComponent {
  store = inject(CombinedStore);
  resource = inject(AppResource)['resource'];

  atLeastOneRiskIsAtStrongLevel: Signal<boolean> = computed(() =>
    this.arrayClimatic().ClimaticPeril.some((climatic) =>
      climatic.scoring.code.includes(ClimaticStatusCodeEnum.Strong),
    ),
  );

  arrayClimatic = computed(() => this.store.climatic());
}
